import { Permission } from '../../graphql'
import usePermissions from '../../hooks/usePermissions'
import { checkPermissions } from './helpers'

export type PermissionsCheckProps = {
  children: JSX.Element,
  permissionsToCheck: Permission[],
  renderNoAccess?: () => JSX.Element,
  renderLoading?: () => JSX.Element,
	operator?: 'every' | 'any',
};

export default function PermissionsCheck( { children, permissionsToCheck, renderNoAccess, renderLoading, operator }: PermissionsCheckProps ): JSX.Element | null {
	const { loading, userPermissions } = usePermissions( permissionsToCheck )

	if ( loading ) {
		return renderLoading ? renderLoading() : null
	}

	if ( checkPermissions( userPermissions, permissionsToCheck, operator ) ) {
		return children
	}

	return renderNoAccess ? renderNoAccess() : null
}
